"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.azureOpenAINode = azureOpenAINode;
exports.llmServiceNode = llmServiceNode;
exports.apiSpecNode = apiSpecNode;
exports.apiSpecWithSearchNode = apiSpecWithSearchNode;
exports.inputOrSearchAPISpecNode = inputOrSearchAPISpecNode;
exports.foundryNode = foundryNode;
const featureFlags_1 = require("../../common/featureFlags");
const localizeUtils_1 = require("../../common/localizeUtils");
const create_1 = require("../create");
const questionNames_1 = require("../questionNames");
function azureOpenAINode(condition) {
    return {
        condition: condition,
        data: {
            type: "text",
            password: true,
            name: questionNames_1.QuestionNames.AzureOpenAIKey,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIKey.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIKey.placeholder"),
        },
        children: [
            {
                condition: (inputs) => {
                    return inputs[questionNames_1.QuestionNames.AzureOpenAIKey]?.length > 0;
                },
                data: {
                    type: "text",
                    name: questionNames_1.QuestionNames.AzureOpenAIEndpoint,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIEndpoint.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIEndpoint.placeholder"),
                },
                children: [
                    {
                        condition: (inputs) => {
                            return inputs[questionNames_1.QuestionNames.AzureOpenAIEndpoint]?.length > 0;
                        },
                        data: {
                            type: "text",
                            name: questionNames_1.QuestionNames.AzureOpenAIDeploymentName,
                            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIDeploymentName.title"),
                            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIDeploymentName.placeholder"),
                        },
                    },
                ],
            },
        ],
    };
}
function llmServiceNode(condition) {
    return {
        condition: condition,
        data: {
            type: "singleSelect",
            name: questionNames_1.QuestionNames.LLMService,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.placeholder"),
            staticOptions: [
                {
                    id: "llm-service-azure-openai",
                    label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceAzureOpenAIOption.label"),
                    detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceAzureOpenAIOption.detail"),
                },
                {
                    id: "llm-service-openai",
                    label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceOpenAIOption.label"),
                    detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceOpenAIOption.detail"),
                },
            ],
            skipSingleOption: true,
            default: "llm-service-azure-openai",
        },
        children: [
            azureOpenAINode({ equals: "llm-service-azure-openai" }),
            {
                condition: { equals: "llm-service-openai" },
                data: {
                    type: "text",
                    password: true,
                    name: questionNames_1.QuestionNames.OpenAIKey,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.openAIKey.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.openAIKey.placeholder"),
                },
            },
        ],
    };
}
function apiSpecNode(condition) {
    return {
        condition: condition,
        data: { type: "group", name: questionNames_1.QuestionNames.FromExistingApi },
        children: [
            {
                data: (0, create_1.apiSpecLocationQuestion)(),
            },
            {
                condition: (inputs) => {
                    return !inputs[questionNames_1.QuestionNames.ActionManifestPath];
                },
                data: (0, create_1.apiOperationQuestion)(),
            },
        ],
    };
}
function apiSpecWithSearchNode() {
    return {
        data: { type: "group", name: questionNames_1.QuestionNames.FromExistingApi },
        condition: { equals: "api-spec" },
        children: [inputOrSearchAPISpecNode()],
    };
}
function inputOrSearchAPISpecNode() {
    return {
        data: (0, create_1.apiSpecTypeSelectQuestion)(),
        condition: (inputs) => {
            return featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaNPMIntegration);
        },
        children: [
            {
                condition: { equals: "enter-url" },
                data: (0, create_1.apiSpecUrlQuestion)(),
                children: [
                    {
                        condition: (inputs) => {
                            return !inputs[questionNames_1.QuestionNames.ActionManifestPath];
                        },
                        data: (0, create_1.apiOperationQuestion)(true, true),
                    },
                ],
            },
            {
                condition: { equals: "open-file" },
                data: (0, create_1.apiSpecFileQuestion)(),
                children: [
                    {
                        condition: (inputs) => {
                            return !inputs[questionNames_1.QuestionNames.ActionManifestPath];
                        },
                        data: (0, create_1.apiOperationQuestion)(true, true),
                    },
                ],
            },
            {
                condition: { equals: "search-api" },
                data: (0, create_1.searchOpenAPISpecQueryQuestion)(),
                children: [
                    {
                        data: (0, create_1.selectOpenApiSpecQuestion)(),
                    },
                    {
                        condition: (inputs) => {
                            return !!inputs[questionNames_1.QuestionNames.SelectOpenApiSpec];
                        },
                        data: (0, create_1.apiOperationQuestion)(true, true),
                    },
                ],
            },
        ],
    };
}
function foundryNode(condition) {
    return {
        condition: condition,
        data: (0, create_1.foundryEndpointQuestion)(),
        children: [
            {
                condition: (inputs) => {
                    return inputs[questionNames_1.QuestionNames.FoundryEndpoint]?.length > 0;
                },
                data: (0, create_1.foundryAgentIdQuestion)(),
            },
            // Future: add foundryAgentNameQuestion() here as an alternative to agentId
        ],
    };
}
//# sourceMappingURL=commonNodes.js.map